import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useOrgCapabilities } from '../../hooks/useOrgCapabilities';

export default function OrgPackageBanner() {
  const navigate = useNavigate();
  const { banner, isReadOnly, canManageBilling, catalogPath } = useOrgCapabilities();

  if (!banner?.show) return null;

  return (
    <div className="px-3 pt-3 sm:px-5 lg:px-7">
      <Alert
        type={isReadOnly ? 'warning' : 'info'}
        showIcon
        className="!rounded-xl"
        message={banner.message}
        action={
          canManageBilling ? (
            <Button size="small" type="primary" onClick={() => navigate(catalogPath)}>
              مشاهده پکیج‌ها
            </Button>
          ) : (
            <span className="text-xs text-slate-500">با مدیر سازمان تماس بگیرید</span>
          )
        }
      />
    </div>
  );
}
